import { useMemo } from "react"
import getStoreFeatures from "./getStoreFeatures";

export default function useCheckStoreFeatures(store: string) {
  return useMemo(() => getStoreFeatures(store), [store])
}
